import { jsx as a } from "react/jsx-runtime";
import d from "../../../hooks/useResponsiveProp.js";
import f from "../Box/Box.js";
import "styled-components";
import { useColumnsContext as c } from "../Columns/ColumnsContext.js";
import { widths as u } from "./consts.js";
import { removePaddingFromVisuallyFirst as v } from "./utils.js";
function j({ children: e, width: p, alignX: s }) {
  const {
    collapseOnMobile: n,
    collapseOnTablet: t,
    mobileSpace: i,
    tabletSpace: r,
    desktopSpace: l,
    reverseOnCollapse: m
  } = c(), o = d(p);
  return /* @__PURE__ */ a(
    f,
    {
      display: "flex",
      width: o === "content" ? void 0 : "100%",
      paddingLeft: [
        n ? "none" : i,
        t ? "none" : r,
        l
      ],
      paddingTop: [
        n ? i : "none",
        t ? r : "none",
        "none"
      ],
      justifyContent: s,
      ...v({
        collapseOnMobile: n,
        collapseOnTablet: t,
        reverseOnCollapse: m
      }),
      flex: !o || o === "content" ? void 0 : x(u[o]),
      children: e
    }
  );
}
function x(e) {
  return `0 0 ${e * 100}%`;
}
export {
  j as default
};
